
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDphdG9taWNmdT4 from './kotlinx-atomicfu-atomicfu.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI_ from './kotlinx-browser.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4 from './kotlinx-coroutines-coreWasm.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWlvLWNvcmU_ from './kotlinx-io-kotlinx-io-core.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LXNlcmlhbGl6YXRpb24tY29yZT4 from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import * as PGlvLmt0b3I6a3Rvci1pbz4 from './ktor-ktor-io.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDphdG9taWNmdT4__ALL_EXPORTS } from './kotlinx-atomicfu-atomicfu.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI___ALL_EXPORTS } from './kotlinx-browser.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS } from './kotlinx-coroutines-coreWasm.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWlvLWNvcmU___ALL_EXPORTS } from './kotlinx-io-kotlinx-io-core.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LXNlcmlhbGl6YXRpb24tY29yZT4__ALL_EXPORTS } from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import { __ALL_EXPORTS as PGlvLmt0b3I6a3Rvci1pbz4__ALL_EXPORTS } from './ktor-ktor-io.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const js_code = {
    'io.ktor.util.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.date.Companion_$external_fun' : () => new Date(),
    'io.ktor.util.date.UTC_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.UTC(p0, p1, p2, p3, p4, p5),
    'io.ktor.util.date.Companion_$external_object_getInstance' : () => Date,
    'io.ktor.util.date.Companion_$external_class_instanceof' : (x) => x instanceof Date,
    'io.ktor.util.date.Companion_$external_class_get' : () => Date,
    'io.ktor.util.date.Date_$external_class_instanceof' : (x) => x instanceof Date,
    'io.ktor.util.date.Date_$external_class_get' : () => Date,
    'io.ktor.util._crypto_js_code' : () => ((globalThis ? globalThis.crypto : (window.crypto || window.msCrypto))),
    'io.ktor.util.Crypto_$external_fun' : () => new Crypto(),
    'io.ktor.util.subtle_$external_prop_getter' : (_this) => _this.subtle,
    'io.ktor.util.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
    'io.ktor.util.Crypto_$external_class_instanceof' : (x) => x instanceof Crypto,
    'io.ktor.util.Crypto_$external_class_get' : () => Crypto,
    'io.ktor.util.SubtleCrypto_$external_fun' : () => new SubtleCrypto(),
    'io.ktor.util.digest_$external_fun' : (_this, p0, p1) => _this.digest(p0, p1),
    'io.ktor.util.SubtleCrypto_$external_class_instanceof' : (x) => x instanceof SubtleCrypto,
    'io.ktor.util.SubtleCrypto_$external_class_get' : () => SubtleCrypto,
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.error_$external_fun' : (_this, p0) => _this.error(p0),
    'io.ktor.util.logging.info_$external_fun' : (_this, p0) => _this.info(p0),
    'io.ktor.util.logging.log_$external_fun' : (_this, p0) => _this.log(p0),
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-io-core>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWlvLWNvcmU___ALL_EXPORTS,
    '<io.ktor:ktor-io>': PGlvLmt0b3I6a3Rvci1pbz4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:atomicfu>': PG9yZy5qZXRicmFpbnMua290bGlueDphdG9taWNmdT4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-coroutines-core>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-serialization-core>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LXNlcmlhbGl6YXRpb24tY29yZT4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-browser>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI___ALL_EXPORTS,
};
    